import gql from 'graphql-tag';

export const ARTICLE_COLLECTION = gql`
    query articleCollection($id: String, $title: String, $limit: Int) {
        articleCollection(id: $id, title: $title) {
            ... on ArticleCollection {
                description
                title
                articles(limit: $limit) {
                    items {
                        category {
                            slug
                        }
                        heroImage {
                            url
                            altText
                        }
                        publicationDateAndTime
                        slug
                        snippet
                        title
                    }
                }
            }
            ... on CMSError {
                errorCode
            }
        }
    }
`;
